import { createContext, useContext, useState } from 'react';

export const ThemeContext = createContext();

export function useThemeData() {
  return useContext(ThemeContext);
}

export const ThemeProvider = ({ children }) => {
  const [color, setColor] = useState('#000000');
 
  return (
    <ThemeContext.Provider
      value={{
        color,
        setColor,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
